<template>
  <div>
    <SGPRowComponent no-gutters>
      <SGPColComponent cols="12">
        <label>{{ responsavel.user.name }}</label> - <label class="text-danger">{{ responsavel.user.email }}</label>
      </SGPColComponent>
    </SGPRowComponent>
    <hr>
  </div>
</template>

<script>

export default {
  name: "EquipeResponsaveisComponent",

  props: {
    responsavel: {
      type: Object,
      required: false
    }
  },
}
</script>